import React from 'react';
import PropTypes from 'prop-types';
import { NUMERIC_REGEX } from '../utils/constants';
import { PatternInput } from './PatternInput';

export const NumericInput = React.forwardRef(({ onChange, value, ...props }, ref) => {
  return (
    <PatternInput
      {...props}
      ref={ref}
      value={value}
      onChange={onChange}
      pattern={NUMERIC_REGEX}
      inputMode='numeric'
    />
  );
});

NumericInput.displayName = 'NumericInput';

NumericInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
